import { ResponsiveGeoMap, ResponsiveChoropleth } from '@nivo/geo'
import styles from './CountryGraph.module.scss'
import api from 'helpers/api'
import worldCountries from 'helpers/world_countries'
import { useEffect, useState } from 'react'
import _ from 'lodash'
import Loader from '../../../miscellaneous/Loader/Loader'
import { FaChartPie } from 'react-icons/fa'

const CountryGraph = ({ dateRange }) => {
    const { startDate, endDate } = dateRange;
    const [ data, setData ] = useState(null)
    const [ dataRange, setDataRange ] = useState([ 0, 100 ])
    const [ isLoaded, setIsLoaded ] = useState(false);

    useEffect(() => {
        if (isLoaded === true) {
            setIsLoaded(false)
        }

        getData().then(res => {
            setData(res)
        }).catch(e => {
            console.error(e)
        })
    }, [ dateRange ])

    useEffect(() => {
        if(data !== null) {
            if (data.length > 0) {
                const getMax = Math.max(...data.map(d => d.value))
                const min = Math.min(...data.map(d => d.value))
                const max = getMax > 0 ? Math.round(getMax / 2) : 100
                setDataRange([ min, max ])
                setIsLoaded(true)
            } else {
                setIsLoaded(true)
            }
        }
    }, [ data ])

    const getData = async () => {
        const data = await api.get(`dashboard/activity/graph/machines/bycountries?startDate=${startDate}&endDate=${endDate}`)
        return data.data.data;
    }

    const getPrettyNumber = (number) => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    const topCountries = _.sortBy(data, [ 'value' ]).slice(-7).reverse();
    return (<div className={ styles.countryGraphContainer }>
        { isLoaded ?
            <>
                { data !== null && data.length > 0 ? <><div className={ styles.countryList }>
                    { topCountries.map((c, i) => {
                        return (<div key={ i } className={ styles.countryRow }>
                            <div>{ c.name }</div>
                            <div>{ getPrettyNumber(c.value) }</div>
                        </div>)
                    }) }
                </div>
                    <div style={ { width: '100%', height: 600 } }>
                        <ResponsiveChoropleth
                            data={ data }
                            features={ worldCountries.features }
                            margin={ { top: 50, right: 0, bottom: 0, left: 0 } }
                            colors={ [
                                '#93d5ed',
                                '#5c9ceb',
                                '#2e7de4',
                                '#1d5ba6',
                            ] }
                            unknownColor="#dddddd"
                            label="properties.name"
                            domain={ dataRange }
                            fillColor="#dddddd"
                            borderWidth={ 1 }
                            valueFormat=".2s"
                            borderColor="#fff"
                            enableGraticule={ false }
                            graticuleLineColor="#dddddd"
                            projectionScale={ 75 }
                        />
                    </div></> : <div className={ `${styles.noData}` }>
                    <FaChartPie />
                    No data
                </div> }
            </> : <Loader color="#ddd"></Loader> }
    </div>)
}


export default CountryGraph;